var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"feature-description"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.body)}}),(_vm.tooltip)?_c('Tooltip',{staticClass:"feature-description-tooltip",attrs:{"content":_vm.tooltip}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }